<template>
  <div class="charge-rule">
    <!-- <div class="content-left">
      <AreaTree ref="areaTree" v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>规则名称:</label>
            <input
              clearable
              v-model="search.name"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="add_btn"
                @click="addOrEdit()"
              >
                添加
              </button>
            </span>
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <div class="list">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="物业"
            prop="propertyName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="规则名称"
            prop="name"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="费用(月)"
            prop="amount"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="生效日期"
            prop="crtTime"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="150px">
            <template slot-scope="scope">
              <button
                type="button"
                class="edit"
                @click="addOrEdit(scope.row.id)"
              >
                修改
              </button>
              <button class="delete" @click="del(scope.row.id)">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
    <!-- 添加/编辑收费规则-->
    <el-dialog
      title="添加/编辑收费规则"
      :visible.sync="dialogFormVisibleChargeRule"
      width="430px"
      :close-on-click-modal="false"
      :lock-scroll="false"
      @close="closeDialog"
    >
      <el-form
        :rules="rules"
        :model="chargeRule"
        ref="formArea"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="物业" prop="propertyId">
          <el-col :span="18">
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="chargeRule.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="规则名称" prop="name">
          <el-col :span="18">
            <el-input v-model.trim="chargeRule.name"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="费用(月)" prop="monthlyPrice">
          <el-col :span="18">
            <el-input v-model.trim="chargeRule.monthlyPrice"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisibleChargeRule = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  getMonthlyChargeRule,
  getOneMonthlyChargeRule,
  addOrEditMonthlyChargeRule,
  getAllParkingsByEnabled,
  fetchPropertyList,
} from "@/api/url";

import Page from "../../commons/page";

import AreaTree from "../../commons/areaTree";

export default {
  data() {
    return {
      moduleName: "parking",
      propertyList: [],
      tableListData: [],
      allParkings: [],
      dialogFormVisibleChargeRule: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        name: null,
        propertyId: null,
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      chargeRule: {
        monthlyPrice: null,
        name: null,
        id: null,
        propertyId: null,
      },
      rules: {
        name: [{ required: true, message: "请填写规则名称", trigger: "blur" }],
        monthlyPrice: [
          { required: true, message: "请填写费用", trigger: "blur" },
        ],
        propertyId: [
          {
            required: true,
            message: "请选择物业",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList(curPage) {
      var _this = this;
      const { propertyId, pageSize, name } = this.search;
      this.$get(getMonthlyChargeRule(), {
        enabledFlag: "y",
        parentId: propertyId ? propertyId : null,
        limit: pageSize,
        page: curPage,
        name: name ? name : null,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        const {
          data: { rows },
        } = data;
        _this.tableListData = rows.map((item) => {
          if (item.parentId && typeof JSON.parse(item.parentId) === "object") {
            item.propertyName = JSON.parse(item.parentId).name;
          }
          return item;
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    addOrEdit(id) {
      if (!id) {
        this.dialogFormVisibleChargeRule = true;
        this.chargeRule = {
          id: null,
          name: null,
          monthlyPrice: null,
          propertyId: null,
        };
      } else {
        this.dialogFormVisibleChargeRule = true;
        this.$get(getOneMonthlyChargeRule() + "/" + id).then((res) => {
          const {
            status,
            data: { id, name, amount, parentId },
          } = res;
          if (status !== 200) return;
          this.chargeRule = {
            id,
            name,
            monthlyPrice: amount,
            propertyId: parentId,
          };
        });
      }
    },
    addEditTrue() {
      this.$refs["formArea"].validate((valid, noStri) => {
        if (valid) {
          const { propertyId, monthlyPrice, name, id } = this.chargeRule;
          if (this.chargeRule.id) {
            this.$putRequest(getOneMonthlyChargeRule() + "/" + id, {
              parentId: propertyId,
              amount: monthlyPrice,
              name,
              id,
            }).then((data) => {
              if (data.status != 200) return;
              this.$notify({
                type: "success",
                title: "成功",
                message: "收费规则修改成功!",
              });
              this.tableList(this.page.curIndex);
            });
            this.dialogFormVisibleChargeRule = false;
          } else {
            this.$postRequest(getOneMonthlyChargeRule(), {
              parentId: propertyId,
              amount: monthlyPrice,
              name,
            }).then((data) => {
              if (data.status != 200) return;
              this.$notify({
                type: "success",
                title: "成功",
                message: "收费规则设置成功!",
              });
              this.search.pageNumber = 1;
              this.tableList(this.search.pageNumber);
              this.dialogFormVisibleChargeRule = false;
            });
          }
        } else {
          return;
        }
      });
    },
    del(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this
            .$deleteRequest(getOneMonthlyChargeRule() + "/" + id)
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功!",
              });
              _this.tableList(_this.page.curIndex);
            });
        }
      );
    },
    allParking() {
      this.$get(getAllParkingsByEnabled()).then((data) => {
        if (data.status != 200) return;
        this.allParkings = data.data.rows;
      });
    },
    searchList: function () {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    resetForm() {
      this.$refs["formArea"].resetFields();
    },
    closeDialog() {
      this.resetForm();
    },
    getAllProperty() {
      this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
  },

  mounted() {
    this.getAllProperty();
    this.tableList(this.search.pageNumber);
  },
  computed: {
    ...mapState(["page"]),
  },
  components: {
    Page,
    AreaTree,
  },
};
</script>
<style>
</style>